module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA2CAMAAADnEdnLAAAAM1BMVEX////ljjjyy67srnv88+zvvZb55tnxxKL12cT9+fb67OPonl3nlkvqpm3338/tton00rkvB6VBAAAAw0lEQVR4Xu3SyW7DMAyEYQ5J7bKd93/aErKTJq2oQ5db/pOBDyNeTP/Wu8xWHKBJRFhfWGAxWRln+ZmTbEA0VZOeAtALPRdPTucjDMQpNxTj7PBZ7YC6vJsmcrgcAJgcrg1olRzWDhyFPBYgEHm8A0JzvhkH3OOvzMabwyVGNY6PKv1hmuM9nnDEZ3OW0ebx9eExj4LHVz9bt9VtRluteX1bIIt1AfLiNgPqc+2QYbwH9G+cgHpNp/9iuNFIRA6l3/TuA4S4BNSnYYelAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/pin_dec.png
// module id = 1686
// module chunks = 1